module.exports = __webpack_public_path__ + "static/media/f_faceshape_long_vector.2eaa65b6.svg";